<template>
    <div>
        <el-dialog title="智能识别" :visible.sync="isVisible" append-to-body>
            <el-form ref="form" :model="form" label-width="80px" :rules="rules">
                <el-form-item label="地址" prop="address">
                    <el-input v-model="form.address"
                        placeholder="请输入或粘贴地址文本，可自动识别姓名电话和 详细地址。 格式为：xx省xx区xx市xx街道 张三 151xxxxxxxx" type="textarea"
                        :rows="4" size="mini" maxlength="255" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelDataScope">取 消</el-button>
                <el-button type="primary" @click="submitForm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import smartParse from '@/utils/smart/address_parse'
export default {
    name: "smartParsePro",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String || Number,
        },
    },
    computed: {
        isVisible: {
            get() {
                return this.visible;
            },
            set() {
                this.cancelDataScope();
            },
        },
        title() {
            return this.type == "add" ? "添加" : "编辑";
        },
    },
    data() {
        return {
            form: {
                image: null
            },
            selectImg: null,
            skipList: [],
            // 表单校验
            rules: {
                address: [
                    { required: true, message: "请输入地址", trigger: "change" }
                ],
            }
        };
    },
    methods: {
        // 关闭弹窗
        close() {
            this.$emit("close");
        },
        // 关闭后重置表单数据
        reset() {
            this.$refs["form"].clearValidate();
            this.$refs["form"].resetFields();
        },
        // 表单提交验证
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let data = smartParse(this.form.address);
                    console.log(data)
                    this.$emit("submitData", data, this.type);
                    // this.$modal.msgSuccess("操作成功");
                    this.$message.success('操作成功');
                    setTimeout(() => {
                        this.cancelDataScope();
                    }, 1500)
                }
            });
        },
        setSubmit() {
            if (this.type == "add") {
                this.save();
            } else {
                this.editForm();
            }
        },
        saveForm() { },
        editForm() { },
        cancelDataScope() {
            this.reset();
            this.close();
        },
        upload(val) {
            this.form.image = val;
            this.$refs.form.validateField('image');
        },
    },
};
</script>

<style lang="scss" scoped></style>